// extracted by mini-css-extract-plugin
export var backgroundImage = "Image-module--backgroundImage--2c8ca";
export var imagePictureEl = "Image-module--imagePictureEl--7bdf0";
export var imageWrapper = "Image-module--imageWrapper--d350e";
export var isCached = "Image-module--isCached--6d634";
export var isLoaded = "Image-module--isLoaded--1dcf3";
export var isNotCached = "Image-module--isNotCached--b943b";
export var placehodlerPictureEl = "Image-module--placehodlerPictureEl--d771d";